export enum EEligibilityStep {
    PROJECT_TYPE = 1,
    ABOUT = 2,
    VOUCHERS = 3,
    LOCATION = 4,
    PROJECT_SIZE = 5,
    CONFIRMATION = 6,
}

export const ELIGIBILITY_STEP_BREADCRUMBS = {
    [EEligibilityStep.PROJECT_TYPE]: "Home",
    [EEligibilityStep.ABOUT]: "About Your Project",
    [EEligibilityStep.VOUCHERS]: "Vouchers",
    [EEligibilityStep.LOCATION]: "Project Location",
    [EEligibilityStep.PROJECT_SIZE]: "Project Size",
    [EEligibilityStep.CONFIRMATION]: "Results",
};
